import React from 'react';
import { updateInvestorAffiliationMutation } from '../../../apollo';
import InvestorAffiliationsForm from './InvestorAffiliationsForm';
import AccountForm from '../AccountForm';

const InvestorAffiliations = (props) => (
  <AccountForm
    title='Investor Affiliations'
    Form={InvestorAffiliationsForm}
    mutation={updateInvestorAffiliationMutation}
    {...props}
  />
);

export default InvestorAffiliations;



// WEBPACK FOOTER //
// ./src/components/Account/InvestorAffiliations/index.js